const Countdown = {
    // Backbone-like structure
    $el: $('.24-repeat .countdown'),

    countdown_interval: null,
    total_seconds: 0,

    // Initialize the countdown  
    init() {
        // DOM
        this.$ = {
            hours: this.$el.find('.bloc-time.hours .figure'),
            minutes: this.$el.find('.bloc-time.min .figure'),
            seconds: this.$el.find('.bloc-time.sec .figure')
        };

        // Calculate time remaining until 12 AM
        this.calculateTimeUntilMidnight();

        this.count();
    },

    calculateTimeUntilMidnight() {
        const now = new Date();
        const midnight = new Date();
        midnight.setHours(24, 0, 0, 0);

        this.total_seconds = Math.floor((midnight - now) / 1000);

        const hours = Math.floor(this.total_seconds / 3600);
        const minutes = Math.floor((this.total_seconds % 3600) / 60);
        const seconds = this.total_seconds % 60;

        this.values = {
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    },

    count() {
        const $hour_1 = this.$.hours.eq(0);
        const $hour_2 = this.$.hours.eq(1);
        const $min_1 = this.$.minutes.eq(0);
        const $min_2 = this.$.minutes.eq(1);
        const $sec_1 = this.$.seconds.eq(0);
        const $sec_2 = this.$.seconds.eq(1);

        this.countdown_interval = setInterval(() => {
            if (this.total_seconds > 0) {
                --this.values.seconds;

                if (this.values.minutes >= 0 && this.values.seconds < 0) {
                    this.values.seconds = 59;
                    --this.values.minutes;
                }

                if (this.values.hours >= 0 && this.values.minutes < 0) {
                    this.values.minutes = 59;
                    --this.values.hours;
                }

                // Hours
                this.checkHour(this.values.hours, $hour_1, $hour_2);

                // Minutes
                this.checkHour(this.values.minutes, $min_1, $min_2);

                // Seconds
                this.checkHour(this.values.seconds, $sec_1, $sec_2);

                --this.total_seconds;
            } else {
                this.calculateTimeUntilMidnight();
            }
        }, 1000);
    },

    animateFigure($el, value) {
        const $top = $el.find('.top');
        const $bottom = $el.find('.bottom');
        const $back_top = $el.find('.top-back');
        const $back_bottom = $el.find('.bottom-back');

        $back_top.find('span').html(value);
        $back_bottom.find('span').html(value);

        // Then animate
        TweenMax.to($top, 0.8, {
            rotationX: '-180deg',
            transformPerspective: 300,
            ease: Quart.easeOut,
            onComplete() {
                $top.html(value);
                $bottom.html(value);
                TweenMax.set($top, { rotationX: 0 });
            }
        });

        TweenMax.to($back_top, 0.8, {
            rotationX: 0,
            transformPerspective: 300,
            ease: Quart.easeOut,
            clearProps: 'all'
        });
    },

    checkHour(value, $el_1, $el_2) {
        const val_1 = value.toString().charAt(0);
        const val_2 = value.toString().charAt(1);
        const fig_1_value = $el_1.find('.top').html();
        const fig_2_value = $el_2.find('.top').html();

        if (value >= 10) {
            if (fig_1_value !== val_1) this.animateFigure($el_1, val_1);
            if (fig_2_value !== val_2) this.animateFigure($el_2, val_2);
        } else {
            if (fig_1_value !== '0') this.animateFigure($el_1, '0');
            if (fig_2_value !== val_1) this.animateFigure($el_2, val_1);
        }
    }
};

Countdown.init();
